module.exports = __webpack_public_path__ + "static/img/wdjc1-2.a5a271e.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdjc1-2.png
// module id = 881
// module chunks = 0